import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Spreadsheet = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M5 6.941c0-1.072 0.869-1.941 1.941-1.941h18.118c1.072 0 1.941 0.869 1.941 1.941v18.118c0 1.072-0.869 1.941-1.941 1.941h-18.118c-1.072 0-1.941-0.869-1.941-1.941v-18.118zM9.529 25.059v-3.26h-2.588v3.26h2.588zM9.529 20.169v-3.26h-2.588v3.26h2.588zM9.529 15.28v-3.26h-2.588v3.26h2.588zM9.529 10.39v-3.26h-2.588v3.26h2.588zM17.294 25.059v-3.26h-6.471v3.26h6.471zM17.294 20.169v-3.26h-6.471v3.26h6.471zM17.294 15.28v-3.26h-6.471v3.26h6.471zM17.294 10.39v-3.26h-6.471v3.26h6.471zM25.059 25.059v-3.26h-6.471v3.26h6.471zM25.059 20.169v-3.26h-6.471v3.26h6.471zM25.059 15.28v-3.26h-6.471v3.26h6.471zM25.059 10.39v-3.26h-6.471v3.26h6.471z" />
  </SvgIcon>
);

export default Spreadsheet;
